<template>
  <div class="section-card" v-if="offers && offers.length > 0">
    <div class="section-header">
      <div class="section-title">
        <div class="icon-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 00-3-3.87"></path>
            <path d="M16 3.13a4 4 0 010 7.75"></path>
          </svg>
        </div>
        Current Offers on This ASIN
      </div>
      <div class="section-actions">
        <button class="btn-secondary">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          Export CSV
        </button>
      </div>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th>Seller</th>
          <th class="align-right">Price</th>
          <th>Fulfillment</th>
          <th>Seller Rating</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(offer, index) in offers" :key="index">
          <td>
            <div class="seller-cell">
              <span v-if="offer.hasBuyBox" class="seller-badge winner">Winner</span>
              <span v-if="offer.isMyOffer" class="seller-badge you">You</span>
              <a
                v-if="sellerStorefrontUrl(offer.sellerId)"
                class="seller-id seller-id-link"
                :href="sellerStorefrontUrl(offer.sellerId)"
                target="_blank"
                rel="noopener noreferrer"
              >{{ offer.sellerId }}</a>
              <span v-else class="seller-id">{{ offer.sellerId }}</span>
            </div>
          </td>
          <td class="align-right price-cell" :class="{ winner: offer.hasBuyBox, you: offer.isMyOffer }">
            {{ currencySymbol }}{{ offer.price.toFixed(2) }}
          </td>
          <td>
            <span class="fulfillment-badge" :class="offer.fulfillment.toLowerCase()">
              {{ offer.fulfillment }}
            </span>
          </td>
          <td class="feedback-cell">
            <template v-if="offer.sellerPositiveFeedbackRating != null">
              <span class="feedback-pct">{{ offer.sellerPositiveFeedbackRating }}%</span>
              <span class="feedback-count"> positive · {{ formatFeedbackCount(offer.sellerFeedbackCount) }} ratings</span>
            </template>
            <span v-else class="feedback-count">—</span>
          </td>
          <td>
            <span class="status-text" :class="statusClass(offer)">
              {{ offer.status }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getCurrencyForMarketplace } from '../../utils/currency'
import { getMarketplaceAmazonSuffix } from '../../utils/sellerAccountsFromV1Api'

export default {
  name: 'CurrentOffers',
  props: {
    offers: {
      type: Array,
      default: function() { return [] }
    },
    marketplace: {
      type: String,
      default: 'US'
    }
  },
  computed: {
    currencySymbol() {
      return getCurrencyForMarketplace(this.marketplace)
    }
  },
  methods: {
    statusClass(offer) {
      if (offer.hasBuyBox) return 'winner'
      if (offer.isMyOffer) return 'lost'
      return 'not-winning'
    },
    formatFeedbackCount(count) {
      if (count == null) return '0'
      if (count >= 1000) return (count / 1000).toFixed(count >= 10000 ? 0 : 1).replace(/\.0$/, '') + 'k'
      return String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    sellerStorefrontUrl(sellerId) {
      if (!sellerId || typeof sellerId !== 'string') return null
      var id = sellerId.trim()
      // Amazon seller keys are alphanumeric (e.g. AUDAIMX3GT161); skip names / Unknown
      if (!/^A[A-Z0-9]{9,}$/i.test(id)) return null
      var suffix = getMarketplaceAmazonSuffix(this.marketplace) || 'com'
      return 'https://www.amazon.' + suffix + '/sp?ie=UTF8&seller=' + encodeURIComponent(id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CurrentOffers.vue?d2b6da52